jQuery(document).ready(function($) {
    init();
    

    /**
     * Retorna os campos do checkout não padrão do WooCommerce já preenchidos salvos em sessão via ajax
     */
    async function init() {
        updateFields();

        var data = {};
        data['action'] = 'get_billing_and_shipping_data';
        const response = await ajax(data);

        if (response.shipping_neighborhood) {
            $('input[name=shipping_neighborhood]').val(response.shipping_neighborhood);
            var data = {};
            data['action'] = 'save_billing_data';
            data['shipping_neighborhood'] = $('input[name=shipping_neighborhood]').val();
            ajax(data);
        }

        var input = $('input[name=shipping_neighborhood]');
        if (input.val() !== '') {
            input.closest('.form-row').addClass('show-label');
        } else {
            input.closest('.form-row').removeClass('show-label');
        }


        if(response.shipping_number){
            $('input[name=shipping_number]').val(response.shipping_number);
            $('input[name=shipping_number]').closest('.form-row').addClass('show-label');
            var data = {};
            data['action'] = 'save_billing_data';
            data['shipping_number'] = $('input[name=shipping_number]').val();
            ajax(data);
        }

        if(response.shipping_CPF){
            $('input[name=shipping_CPF]').val(response.shipping_CPF);
            $('input[name=shipping_CPF]').closest('.form-row').addClass('show-label');
            var data = {};
            data['action'] = 'save_billing_data';
            data['shipping_CPF'] = $('input[name=shipping_CPF]').val();
            ajax(data);
        }
        if(response.cart_total){
            $('.show-order-review .cart-total').html(response.cart_total);
        }
    }

    /**
     * Função para salvar os value dos inputs e mostrar no campo info.
     */
    function updateCustomerDetails() {
        const inputOrder = ['billing_first_name', 'billing_last_name', 'billing_email', 'billing_phone', 'shipping_CPF'];
        let customerInfo = '';

        inputOrder.forEach(id => {
            const input = document.getElementById(id);
            if (input) {
                if (id === 'billing_first_name') {
                    customerInfo += `<p>${input.value} `;
                } else if (id === 'billing_last_name') {
                    customerInfo += `${input.value}</p>`;
                } else {
                    customerInfo += `<p>${input.value}</p>`;
                }
            }
        });

        document.querySelector('.customer_details-info').innerHTML = customerInfo;
    }

    /**
     * Função para salvar os value dos inputs e mostrar no campo info.
     */
    function updateCustomerDetailsShipping() {
        const inputOrder = [
            'billing_address_1',
            'shipping_number',
            'shipping_neighborhood',
            'billing_city',
            'billing_state_mask',
            'billing_address_2',
            'billing_postcode'
        ];
        let shippingInfo = '';

        inputOrder.forEach(id => {
            const input = document.getElementById(id);
            if (input) {
                if (id === 'billing_state_mask') {
                    shippingInfo = shippingInfo.replace(/ - $/, ` - ${input.value}</p>`);
                } else if (input.tagName === 'SELECT') {
                    shippingInfo += `<p>${input.options[input.selectedIndex].text}</p>`;
                } else {
                    switch (id) {
                        case 'billing_address_1':
                            shippingInfo += `<p>${input.value}, `;
                            break;
                        case 'shipping_number':
                            shippingInfo += `${input.value}</p>`;
                            break;
                        case 'billing_city':
                            shippingInfo += `<p>${input.value} - `;
                            break;
                        default:
                            shippingInfo += `<p>${input.value}</p>`;
                            break;
                    }
                }
            }
        });

        document.querySelector('.customer_details-shipping .customer_details-info').innerHTML = shippingInfo;
    }


    /**
     * Função para salvar os value dos inputs e mostrar no campo info.
     */
    function updateShippingMethodDetails() {
        const selectedMethod = document.querySelector('input[name="shipping_method[0]"]:checked');
        if (selectedMethod) {
            let labelElement = document.querySelector(`label[for=${selectedMethod.id}]`);
            
            let label = Array.from(labelElement.childNodes)
                .filter(node => !node.classList || !node.classList.contains('woocommerce-Price-amount'))
                .map(node => node.outerHTML || node.textContent || '')
                .join(' ')
                .trim();
    
            if (label.endsWith(':')) {
                label = label.slice(0, -1);
            }
    
            const labelHTML = label.endsWith('.') ? `<p>${label}</p>` : `<p>${label}.</p>`;
    
            const priceElement = document.querySelector(`label[for=${selectedMethod.id}] .woocommerce-Price-amount`);
            let amount = "";
            if (priceElement) {
                amount = priceElement.innerHTML;
            } else if (!label.toLowerCase().includes("grátis")) { 
                amount = "Grátis";
            }
    
            document.querySelector('.checkout-step-shipping-method .customer_details-info').innerHTML = `
                ${labelHTML}
                <p>${amount}</p>
            `;
        }
    }

    /**
     * Verifica fields required
     */
    function requireValidity(fieldsSelector) {
        const formCheckout = document.querySelectorAll(fieldsSelector);
        let formReturn = true;
        let firstInvalidField = null;

        formCheckout.forEach(item => {
            const inputCheckout = item.querySelector('.input-text, select');
            const inputNeighborhood = document.querySelector('#shipping_neighborhood');
            const inputAddress2 = document.querySelector('#billing_address_2');
            const inputBillingState = document.querySelector('#billing_state');

            if (inputCheckout && (!inputNeighborhood || item !== inputNeighborhood.closest('.form-row')) &&
                (!inputAddress2 || item !== inputAddress2.closest('.form-row')) &&
                (!inputBillingState || item !== inputBillingState.closest('.form-row')) ) {
                if (inputCheckout.tagName === 'SELECT') {
                    if (inputCheckout.value === "" || inputCheckout.value === "Selecione o Estado") {
                        item.classList.add("woocommerce-invalid-required-field");
                        if (!firstInvalidField) {
                            firstInvalidField = item;
                        }
                        formReturn = false;
                    } else {
                        item.classList.remove("woocommerce-invalid-required-field");
                    }
                } else if (inputCheckout.value.trim() === "") {
                    item.classList.add("woocommerce-invalid-required-field");
                    if (!firstInvalidField) {
                        firstInvalidField = item;
                    }
                    formReturn = false;
                } else {
                    item.classList.remove("woocommerce-invalid-required-field");
                }
            }
        });

        if (firstInvalidField) {
            const headerWrapper = document.querySelector('.header-wrapper');
            const headerHeight = headerWrapper ? headerWrapper.offsetHeight : 0;
            const offsetPosition = firstInvalidField.getBoundingClientRect().top + window.pageYOffset - headerHeight - 50;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }

        return formReturn;
    }


    /**
     *  Desabilita e habilita o botão NEXT
    */
    $(document).ready(function (){
        $('.btn-next').on('click', function() {
            validate();
            $('#billing_email, #billing_first_name, #billing_last_name, #billing_postcode, #billing_address_1, #shipping_number, #billing_state, #billing_city, #billing_phone, #shipping_CPF')
            .keyup(validate);
        });
    });

    function validate() {
        const requiredFields = [
            'billing_email',
            'billing_first_name',
            'billing_last_name',
            'billing_postcode',
            'billing_address_1',
            'shipping_number',
            'billing_state',
            'billing_city',
            'billing_phone',
            'shipping_CPF'
        ];

        if (typeof isUserLoggedIn !== "undefined" && isUserLoggedIn) {
            requiredFields.splice(0, 1);
        }

      let allFieldsValid = true;

        $.each(requiredFields, function(index, fieldId) {
            const checkoutField = $(`#${fieldId}`);
            if (checkoutField.length === 0 || checkoutField.val().trim() === '') {
                allFieldsValid = false;
                return false;
            }
        });

        if (allFieldsValid) {
            $('#place_order-next').removeClass('disabled-button');
        } else {
            $('#place_order-next').addClass('disabled-button');
        }
    }

    /**
     * Verifica e-mail
     */
    function emailVerification() {
        const inputEmail = document.querySelector('.woocommerce-invalid-email');

        if(inputEmail) {
            return false;
        } else {
            return true;
        }
    }

    /**
     * Função para rolagem dos blocos
     */
    function scrollToSection(section) {
        if (window.innerWidth <= 999) {
            const headerHeight = $('.header-wrapper').outerHeight();
            const targetPosition = $(section).offset().top - headerHeight - 100;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    }

    /**
     * Validação do telefone
     */
    function phoneValidity(value) {
        const input = value.replace(/\D/g, '');
        return input.length === 11;
    }

    $("#billing_phone").keyup(function () {
        const isValidPhone = phoneValidity(this.value);

        if(isValidPhone) {
            $('#billing_phone_field').removeClass("woocommerce-invalid-required-field-valid-phone");
        }
    });

    /**
     * Validação do Cep
     */
    function cepValidity(value) { 
        const input = value.replace(/\D/g, '');
        return input.length === 8;
    }

    $("#billing_postcode").keyup(function () {
        const isValidCep = cepValidity(this.value);

        if(isValidCep) {
            $('#billing_postcode_field').removeClass("woocommerce-invalid-required-field-valid-cep");
        }
    });

    const showElement = ($element) => {
        $element.addClass('show-block').removeClass('hide-block');
    };

    const hideElement = ($element) => {
        $element.addClass('hide-block').removeClass('show-block');
    };

    const removeElement = ($element) => {
        $element.removeClass('hide-block show-block');
    };

    /**
     * Botões 'Dados cadastrais'
     */
    $('#place_order-registrations').on('click', () => {
        const billingPhone = $('#billing_phone').val();

        if (phoneValidity(billingPhone) || billingPhone === '') {
            $('#billing_phone_field').removeClass("woocommerce-invalid-required-field-valid-phone");
        } else {
            $('#billing_phone_field').addClass("woocommerce-invalid-required-field-valid-phone");

            const headerHeight = $('.header-wrapper').outerHeight();
            const targetPosition = $('#billing_phone_field').offset().top - headerHeight - 50;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });

            return;
        }

        const cpfField = document.querySelector('.cpf-erro');
        if (cpfField) {
            return;
        }

        if (!requireValidity(".customer_details-registrations-fields .form-row")) {
            return;
        }

        if (!emailVerification()) {
            return;
        }

        updateCustomerDetails();

        hideElement($('.customer_details-registrations'));
        showElement($('.customer_details-shipping'));

        scrollToSection('[data-step="step-shipping"]');
    });


    $('.customer_details-registrations .registrations-changes').on('click', () => {
        showElement($('.customer_details-registrations'));
        removeElement($('.customer_details-shipping'));
        removeElement($('.checkout-step-shipping-method'));
        removeElement($('.checkout-step-payment'));
    });

    /**
     * Botões 'Endereço de entrega'
     */
    $('#place_order-shipping').on('click', () => {
        const billingCep = $('#billing_postcode').val();

        if (cepValidity(billingCep) || billingCep === '') {
            $('#billing_postcode_field').removeClass("woocommerce-invalid-required-field-valid-cep");
        } else {
            $('#billing_postcode_field').addClass("woocommerce-invalid-required-field-valid-cep");

            const headerHeight = $('.header-wrapper').outerHeight();
            const targetPosition = $('#billing_postcode_field').offset().top - headerHeight - 50;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });

            return;
        }

        if (!requireValidity(".customer_details-shipping .form-row")) {
            return;
        }

        updateCustomerDetailsShipping()

        const stepShippingMethod = document.querySelector('.checkout-step-shipping-method')
        if(stepShippingMethod) {
            hideElement($('.customer_details-shipping'));
            showElement($('.checkout-step-shipping-method'));

            scrollToSection('[data-step="step-shipping-method"]');

            $( 'body' ).trigger( 'update_checkout' );
        } else {
            hideElement($('.customer_details-shipping'));
            showElement($('.checkout-step-payment'));

            scrollToSection('[data-step="step-payment"]');
        }

        $('#cart-shipping').removeClass('hide-line');
    });

    $('.customer_details-shipping .registrations-changes').on('click', () => {
        showElement($('.customer_details-shipping'));
        removeElement($('.checkout-step-shipping-method'));
        removeElement($('.checkout-step-payment'));
    });

    /**
     * Botões 'Formas de entrega'
     */
    $('#place_order-shipping-method').on('click', () => {
        const shippingMethod = document.querySelector('.checkout-step-shipping-method #shipping_method');

        if (!shippingMethod) {
            event.preventDefault();
            alert('Método de envio não selecionado!');
            return;
        }

        updateShippingMethodDetails();

        hideElement($('.checkout-step-shipping-method'));
        showElement($('.checkout-step-payment'));

        scrollToSection('[data-step="step-payment"]');
    });

    $('.checkout-step-shipping-method .registrations-changes').on('click', () => {
        showElement($('.checkout-step-shipping-method'));
        removeElement($('.checkout-step-payment'));
    });

    /**
     * Salva os campos do formulário quando alterados
     */
    $('input, select').on('change', function(e) {
        var data = {};
        data['action'] = 'save_billing_data';
        data[$(this).attr('name')] = $(this).val();
        ajax(data);
        updateFields();
    });

    /**
     * Ajax
     */
    async function ajax(data){
       return await jQuery.post(wcParams.adminAjax, data);
    }

    /**
     * Atualizando fields de info
     */
    function updateFields(){
        $('.contact-value').text($('input[name=billing_email]').val());
        $('.billing-value .billing_first_name').text($('input[name=billing_first_name]').val()+' ');
        $('.billing-value .billing_last_name').text($('input[name=billing_last_name]').val()+' ');
        $('.billing-value .billing_address_1').text($('input[name=billing_address_1]').val()+' ');
        $('.billing-value .billing_number').text($('input[name=shipping_number]').val()+' ');

        if($('#billing_address_2').val() != "") {
            $('.billing-value .billing_address_2').text($('input[name=billing_address_2]').val()+', ');
        } else {
            $('.billing-value .billing_address_2').text($('input[name=billing_address_2]').val()+' ');
        }

        $('.billing-value .billing_neighborhood').text($('input[name=shipping_neighborhood]').val()+' ');
        $('.billing-value .billing_city').text($('input[name=billing_city]').val()+' - ');
        $('.billing-value .billing_state').text($('select[name=billing_state]').val()+' ');
        $('.billing-value .billing_postcode').text($('input[name=billing_postcode]').val()+' ');
        $('.billing-value .billing_country').text($('input[name=billing_country]').val());
        $('.shipping-value').text($('input.shipping_method:checked').next().text().split(":")[0]);
    }

    $('body').on('update_checkout', async function() {
      $('.woocommerce-shipping-totals').block({
          message: null,
          overlayCSS: {
              background: '#fff',
              opacity: 0.6
          }
      });
    });

    $('body').on('updated_checkout', function() {
      // Lê o total do resumo que o WooCommerce acabou de renderizar (mesmo valor de
      // WC()->cart->get_total()), eliminando um admin-ajax redundante a cada updated_checkout.
      var $total = $('.woocommerce-checkout-review-order-table .order-total td strong').first();
      if ($total.length) {
          $('.show-order-review .cart-total').html($total.html());
      }
    });

    $('body.woocommerce-checkout').on('click', 'button[name="apply_coupon"]', function(e) {
        var $form = $( 'form.checkout_coupon' );

        if ( $form.is( '.processing' ) ) {
            return false;
        }

        $form.addClass( 'processing' ).block({
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.6
            }
        });

        var data = {
            security: wc_checkout_params.apply_coupon_nonce,
            coupon_code: $form.find( 'input[name="coupon_code"]' ).val()
        };

        $.ajax({
          type: 'POST',
          url: wc_checkout_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'apply_coupon' ),
          data: data,
          success: function( code ) {
              $( '.woocommerce-error, .woocommerce-message' ).remove();
              $form.removeClass( 'processing' ).unblock();

              if ( code ) {
                  $('.checkout').before( code );

                  $( document.body ).trigger( 'applied_coupon_in_checkout', [data.coupon_code] );
                  $( document.body ).trigger( 'update_checkout', { update_shipping_method: false } );
              }
          },
          dataType: 'html'
        });

        e.preventDefault();
        return false;
    });

    $('#billing_state_mask').on('change', () => {
        $('#billing_state').val( $('#billing_state_mask').val() );
        $( document.body ).trigger( 'update_checkout', { update_shipping_method: true } );
    });
});




